import React from "react";

const ImageComponent = ({
  src,
  alt,
  width = "16.52px",
  height = "15.51px",
  className = "",
  ...props
}) => {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      {...props}
    />
  );
};

export default ImageComponent;
